import * as React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import Modal from 'react-modal';

import HideMessageDialog from 'chat/components/AnnouncementStream/components/HideMessageDialog';
import Icon from 'components/Icon';
import Menu from 'components/Menu';
import MenuButton from 'components/MenuButton';
import MenuItem from 'components/MenuItem';
import TextWithIcon from 'components/TextWithIcon';

export type Props = {
  groupName: string;
  messageUuid: string;
  streamUuid: string;
};

const ExtraActionsButton: React.FC<Props> = ({ groupName, messageUuid, streamUuid }) => {
  const { formatMessage } = useIntl();
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <React.Fragment>
      <Modal isOpen={isModalOpen}>
        <HideMessageDialog
          groupName={groupName}
          messageUuid={messageUuid}
          onConfirm={() => setIsModalOpen(false)}
          onCancel={() => setIsModalOpen(false)}
          streamUuid={streamUuid}
        />
      </Modal>
      <MenuButton
        aria-label={formatMessage({ id: 'messages.buttons.extraActions' })}
        size="small"
        menu={
          <Menu rowHover>
            <MenuItem onClick={() => setIsModalOpen(true)}>
              <TextWithIcon color="chalkboard" icon="eye-off" iconColor="chalkboard">
                <FormattedMessage id="hideMessageDialog.buttons.hideMessage" />
              </TextWithIcon>
            </MenuItem>
          </Menu>
        }
      >
        <Icon name="ellipses" />
      </MenuButton>
    </React.Fragment>
  );
};

export default ExtraActionsButton;
